// Downloading a view as a file: the server writes the whole view with the person's rights, the browser only saves what came.

/** The file name from the server's Content-Disposition; the name with a Russian section is given in UTF-8. */
function fileNameOf(header: string | null): string | null {
  if (!header) return null;
  const utf = /filename\*=UTF-8''([^;]+)/i.exec(header);
  if (utf) return decodeURIComponent(utf[1]!.replace(/^["']|["']$/g, ''));
  const plain = /filename="?([^";]+)"?/i.exec(header);
  return plain ? plain[1]! : null;
}

/**
 * Asks the server for the export of a view and saves the file it sent. The chosen event narrows the rows;
 * `all` means every event. The number of rows in the file is in the answer — it may be more than the table shows.
 */
export async function downloadExport(typeId: string, viewId: string | null, scopeId: string | null, now?: { filter: unknown; search: string }): Promise<{ name: string; rows: number }> {
  const p = new URLSearchParams();
  if (viewId) p.set('view', viewId);
  p.set('scope', scopeId ?? 'all');
  // What the table shows now (J5): a filter set but not saved and the search narrow the file the same way.
  if (now) { p.set('filter', JSON.stringify(now.filter ?? null)); if (now.search.trim()) p.set('search', now.search.trim()); }
  const res = await fetch(`/api/export/${typeId}?${p.toString()}`);
  if (!res.ok) {
    const j = await res.json().catch(() => null) as { error?: { message?: string } } | null;
    throw new Error(j?.error?.message ?? 'Выгрузить не удалось');
  }
  const blob = await res.blob();
  const name = fileNameOf(res.headers.get('content-disposition')) ?? 'export.csv';
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = name; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
  return { name, rows: Number(res.headers.get('x-export-rows') ?? 0) };
}
